/* Svensk katalog for locale-payroll-delivery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'err.payslip.notAuthorized': 'Du har inte åtkomst till den här begäran om utskick.',
  'err.payslip.approvedRunRequired': 'Godkänn lönekörningen innan lönebeskeden läggs i kö.',
  'err.payslip.queueTooLarge': 'Lönebeskedsdatan är för stor för att läggas i kö. Kontakta supporten.',
  'pay.payslipSent': 'Lönebesked skickat.',
  'pay.payslipsSent': 'Lönebesked skickade.',
  'pay.payslipsSentAndPosted': 'Lönebesked skickade och lön bokförd.',
  'pay.payslipsQueuedAndPosted': 'Lön bokförd. Lönebesked lagda i utskickskön.',
  'pay.payslipQueued': 'I kö för utskick',
  'pay.payslipsQueued': 'Lönebesked i utskickskön.',
  'pay.payslipGenerated': 'Genererat',
  'pay.payslipNotReady': 'Inte klart',
  'pay.payslipScheduled': 'Schemalagt',
});
